import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Applications from "./pages/admin/Applications";
import Publishers from "./pages/admin/Publishers";
import Faqs from "./pages/admin/Faqs";
import Settings from "./pages/admin/Settings";
import ContactSettings from "./pages/admin/ContactSettings";
import Users from "./pages/admin/Users";
import AdminGifts from "./pages/admin/Gifts";
import AdminVideos from "./pages/admin/Videos";
import BulkMessages from "./pages/admin/BulkMessages";
import TextCleaner from "./pages/admin/TextCleaner";
import PublisherArchive from "./pages/admin/PublisherArchive";
import KickAlerts from "./pages/admin/KickAlerts";
import LeagueRankings from "./pages/admin/LeagueRankings";
import Grouper from "./pages/admin/Grouper";
import KickOverlay from "./pages/KickOverlay";
import MemberPanel from "./pages/MemberPanel";
import ResetPassword from "./pages/ResetPassword";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-loading">
        <div className="w-10 h-10 rounded-full border-2 border-cyan-400 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/giris" state={{ from: location }} replace />;
  return children;
}

function App() {
  const isOverlay = window.location.pathname.startsWith("/overlay/");
  return (
    <div className={isOverlay ? "App" : "App bg-[#050505] min-h-screen"}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/giris" element={<Login />} />
            <Route path="/sifre-sifirla" element={<ResetPassword />} />
            <Route path="/overlay/kick/:token" element={<KickOverlay />} />
            <Route path="/panel" element={<Protected><MemberPanel /></Protected>} />
            <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="basvurular" element={<Applications />} />
              <Route path="yayincilar" element={<Publishers />} />
              <Route path="kullanicilar" element={<Users />} />
              <Route path="hediyeler" element={<AdminGifts />} />
              <Route path="videolar" element={<AdminVideos />} />
              <Route path="mesaj" element={<BulkMessages />} />
              <Route path="metin" element={<TextCleaner />} />
              <Route path="kick" element={<KickAlerts />} />
              <Route path="lig" element={<LeagueRankings />} />
              <Route path="gruplar" element={<Grouper />} />
              <Route path="arsiv" element={<PublisherArchive />} />
              <Route path="sss" element={<Faqs />} />
              <Route path="ayarlar" element={<Settings />} />
              <Route path="iletisim" element={<ContactSettings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
